import { Box } from '../../common/ui/Box';
import { VesselTankStocks } from '../../vessel/VesselTanks/VesselTankStocks';

import { useVesselTanks } from './hooks/useVesselTanks';

export const OrderVesselTanks = ({ vesselId }) => {
    const vesselTanksQuery = useVesselTanks({ vesselId, enabled: !!vesselId });

    if (vesselTanksQuery.isPending || !vesselTanksQuery.data?.vesselTanks?.length) {
        return null;
    }

    return (
        <Box marginY={40}>
            <VesselTankStocks vesselTanks={vesselTanksQuery.data.vesselTanks} />
        </Box>
    );
};
